import MyAccountPage from '@/pages/compliance/MyAccountPage'

export default function NotificationPreferencesPage() {
  return <MyAccountPage section='notifications' />
}
